import React, { useEffect, useState } from 'react';
import { TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { useFindFormTemplates } from '@sierralabs/forms-ui';
const SiteFormPicker = props => {
    const { value, onChange, variant } = props;
    const { formTemplateList, findFormTemplates } = useFindFormTemplates();
    // TODO: implement approach without setting limit
    useEffect(() => findFormTemplates({ limit: 1000 }), [findFormTemplates]);
    const [selected, setSelected] = useState();
    useEffect(() => {
        if (formTemplateList && value) {
            setSelected(formTemplateList === null || formTemplateList === void 0 ? void 0 : formTemplateList.data.find(form => form.id === value));
        }
    }, [formTemplateList, value]);
    // console.log('SiteRoutePicker value', value);
    const additionalInputProps = {};
    if (!variant)
        additionalInputProps.disableUnderline = true;
    // console.log('selected', selected);
    return (React.createElement(Autocomplete, { fullWidth: true, options: (formTemplateList === null || formTemplateList === void 0 ? void 0 : formTemplateList.data) || [], value: selected || null, onChange: (_, value) => {
            if (value) {
                console.log('value', value);
                setSelected(value);
                onChange === null || onChange === void 0 ? void 0 : onChange(value);
            }
        }, getOptionLabel: option => option.name, renderInput: params => (React.createElement(TextField, Object.assign({ variant: variant }, params, { fullWidth: true, size: 'small', label: 'Select Form Template', InputProps: Object.assign(Object.assign({}, params.InputProps), additionalInputProps) }))) }));
};
export default SiteFormPicker;
//# sourceMappingURL=SiteFormPicker.js.map